'use client';
/**
 * RD-3 C7 — 상세(/apt/{slug})는 경로에 지역이 없어 헤더 지역 칩이 지역을 모른다. 상세 페이지가 이 섬을 하나 꽂아 지역 이름을 알린다.
 *
 * ⚠️ 레이아웃(헤더)에서 headers()/cookies() 를 쓰지 않는다(ISR 보존). 헤더는 페이지의 형제 트리라 React Context 가 직접 닿지 않으므로,
 *    모듈 스토어(useSyncExternalStore) 하나가 Context 역할을 한다 — 칩은 useRegionHint() 로 구독한다.
 *    서버 HTML 의 칩은 경로로 정할 수 있는 지역(허브)까지만 맞고, 상세는 수화 직후 이 값으로 바뀐다(자동 이동 없음 · 칩 폭 고정).
 */
import { useEffect, useSyncExternalStore } from 'react';

let hint: string | null = null;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

export function setRegionHint(v: string | null) {
  const next = v && v.trim() ? v.trim() : null;
  if (next === hint) return;
  hint = next;
  emit();
}

const subscribe = (f: () => void) => { subs.add(f); return () => { subs.delete(f); }; };

/** 칩이 읽는 값. 서버·첫 수화 렌더는 항상 null. */
export function useRegionHint(): string | null {
  return useSyncExternalStore(subscribe, () => hint, () => null);
}

export default function RegionHint({ region }: { region: string | null | undefined }) {
  useEffect(() => {
    setRegionHint(region ?? null);
    return () => setRegionHint(null);
  }, [region]);
  return null;
}
